<template>
    <div>
        <slot v-if="err" name="catch"></slot>
        <slot v-else name="try"></slot>
    </div>
  </template>

  <script>
  export default {
    name: "error-boundary",
    props: {
      stopPropagation: Boolean
    },
    data() {
      return {
        err: false,
        vm: null,
        info: null
      };
    },
    errorCaptured(err, vm, info) {
      this.err = err;
      this.vm = vm;
      this.info = info;
      return false;
    }
  };
  </script>

  <style lang="scss" scoped>
  </style>
